import PriceDetails from "./PriceDetails";

const GSTDetails = ({ currency, ticket_tax_details, size, padding }) => {
  if (!ticket_tax_details) return null;

  if (ticket_tax_details.igst_amount) {
    return (
      <PriceDetails
        title={`IGST (${ticket_tax_details.igst_rate}%)`}
        amount={ticket_tax_details.igst_amount}
        currency={currency}
        size={size || "12px"}
        padding={padding}
      />
    );
  }

  if (ticket_tax_details.cgst_amount || ticket_tax_details.sgst_amount) {
    return (
      <>
        {ticket_tax_details.cgst_amount ? (
          <PriceDetails
            title={`CGST (${ticket_tax_details.cgst_rate}%)`}
            amount={ticket_tax_details.cgst_amount}
            currency={currency}
            size={size || "12px"}
            padding={padding}
          />
        ) : null}
        {ticket_tax_details.sgst_amount ? (
          <PriceDetails
            title={`SGST (${ticket_tax_details.sgst_rate}%)`}
            amount={ticket_tax_details.sgst_amount}
            currency={currency}
            size={size || "12px"}
            padding={padding}
          />
        ) : null}
      </>
    );
  }

  if (ticket_tax_details.tax_amount) {
    const label = ticket_tax_details.tax_name || "Tax";
    const rate = ticket_tax_details.tax_rate;
    return (
      <PriceDetails
        title={rate ? `${label} (${rate}%)` : label}
        amount={ticket_tax_details.tax_amount}
        currency={currency}
        size={size || "12px"}
        padding={padding}
      />
    );
  }

  return null;
};

export default GSTDetails;
